// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/approval_flow_type.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/approval_flow_type.proto.
 */
export const file_bfftypes_v1_approval_flow_type: GenFile = /*@__PURE__*/
  fileDesc("CiRiZmZ0eXBlcy92MS9hcHByb3ZhbF9mbG93X3R5cGUucHJvdG8SC2JmZnR5cGVzLnYxKvkCCg9CdXNpbmVzc1Byb2Nlc3MSIAocQlVTSU5FU1NfUFJPQ0VTU19VTlNQRUNJRklFRBAAEiQKIEJVU0lORVNTX1BST0NFU1NfREVNQU5EX0ZPUkVDQVNUEAESHQoZQlVTSU5FU1NfUFJPQ0VTU19TUE9UX0JJRBACEiEKHUJVU0lORVNTX1BST0NFU1NfSU5UUkFEQVlfQklEEAMSJQohQlVTSU5FU1NfUFJPQ0VTU19QUk9DVVJFTUVOVF9QTEFOEAQSJAogQlVTSU5FU1NfUFJPQ0VTU19HRU5FUkFUSU9OX1BMQU4QBRIlCiFCVVNJTkVTU19QUk9DRVNTX1NVUFBSRVNTSU9OX1BMQU4QBhIkCiBCVVNJTkVTU19QUk9DRVNTX0JJTEFURVJBTF9UUkFERRAHEiIKHkJVU0lORVNTX1BST0NFU1NfRlVUVVJFU19UUkFERRAIEh4KGkJVU0lORVNTX1BST0NFU1NfQkxPQ0tfQklEEAkqawoQQXBwcm92YWxTdHJhdGVneRIhCh1BUFBST1ZBTF9TVFJBVEVHWV9VTlNQRUNJRklFRBAAEhkKFUFQUFJPVkFMX1NUUkFURUdZX0FMTBABEhkKFUFQUFJPVkFMX1NUUkFURUdZX0FOWRACKu8BCg9QbGFubmluZ1NlY3Rpb24SIAocUExBTk5JTkdfU0VDVElPTl9VTlNQRUNJRklFRBAAEhoKFlBMQU5OSU5HX1NFQ1RJT05fVE9EQVkQARIdChlQTEFOTklOR19TRUNUSU9OX1RPTU9SUk9XEAISJwojUExBTk5JTkdfU0VDVElPTl9EQVlfQUZURVJfVE9NT1JST1cQAxIbChdQTEFOTklOR19TRUNUSU9OX1dFRUtMWRAEEhwKGFBMQU5OSU5HX1NFQ1RJT05fTU9OVEhMWRAFEhsKF1BMQU5OSU5HX1NFQ1RJT05fQU5OVUFMEAYqfwoMU3dpdGNoUmVhc29uEh0KGVNXSVRDSF9SRUFTT05fVU5TUEVDSUZJRUQQABIaChZTV0lUQ0hfUkVBU09OX1ZBUklBTkNFEAESGgoWU1dJVENIX1JFQVNPTl9ERUFETElORRACEhgKFFNXSVRDSF9SRUFTT05fTUFOVUFMEAMqgAEKDEFwcHJvdmFsTW9kZRIdChlBUFBST1ZBTF9NT0RFX1VOU1BFQ0lGSUVEEAASGgoWQVBQUk9WQUxfTU9ERV9BUFBST1ZBTBABEhYKEkFQUFJPVkFMX01PREVfQVVUTxACEh0KGUFQUFJPVkFMX01PREVfTk9fQVBQUk9WQUwQAypyChBXb3JrZmxvd1NjaGVkdWxlEiEKHVdPUktGTE9XX1NDSEVEVUxFX1VOU1BFQ0lGSUVEEAASHQoZV09SS0ZMT1dfU0NIRURVTEVfUkVHVUxBUhABEhwKGFdPUktGTE9XX1NDSEVEVUxFX0NIQU5HRRACQkJaQGdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnR5cGVzL3YxO2JmZnR5cGVzdjFiBnByb3RvMw");

/**
 * BusinessProcess identifies the business process that an approval flow
 * configuration applies to.
 *
 * Wire values mirror backend types.v1.BusinessProcess but the enum is
 * kept BFF-local so that BFF's contract with the frontend stays decoupled
 * from backend internal types.
 *
 * @generated from enum bfftypes.v1.BusinessProcess
 */
export enum BusinessProcess {
  /**
   * @generated from enum value: BUSINESS_PROCESS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 需要想定
   *
   * @generated from enum value: BUSINESS_PROCESS_DEMAND_FORECAST = 1;
   */
  DEMAND_FORECAST = 1,

  /**
   * スポット入札
   *
   * @generated from enum value: BUSINESS_PROCESS_SPOT_BID = 2;
   */
  SPOT_BID = 2,

  /**
   * 時間前入札
   *
   * @generated from enum value: BUSINESS_PROCESS_INTRADAY_BID = 3;
   */
  INTRADAY_BID = 3,

  /**
   * 需要調達計画提出
   *
   * @generated from enum value: BUSINESS_PROCESS_PROCUREMENT_PLAN = 4;
   */
  PROCUREMENT_PLAN = 4,

  /**
   * 発電販売計画提出
   *
   * @generated from enum value: BUSINESS_PROCESS_GENERATION_PLAN = 5;
   */
  GENERATION_PLAN = 5,

  /**
   * 需要抑制計画提出
   *
   * @generated from enum value: BUSINESS_PROCESS_SUPPRESSION_PLAN = 6;
   */
  SUPPRESSION_PLAN = 6,

  /**
   * 相対取引
   *
   * @generated from enum value: BUSINESS_PROCESS_BILATERAL_TRADE = 7;
   */
  BILATERAL_TRADE = 7,

  /**
   * 先物取引
   *
   * @generated from enum value: BUSINESS_PROCESS_FUTURES_TRADE = 8;
   */
  FUTURES_TRADE = 8,

  /**
   * ブロック入札
   *
   * @generated from enum value: BUSINESS_PROCESS_BLOCK_BID = 9;
   */
  BLOCK_BID = 9,
}

/**
 * Describes the enum bfftypes.v1.BusinessProcess.
 */
export const BusinessProcessSchema: GenEnum<BusinessProcess> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_approval_flow_type, 0);

/**
 * ApprovalStrategy determines how approvals are counted within a single
 * stage.
 *
 * Wire values mirror backend types.v1.ApprovalStrategy.
 *
 * @generated from enum bfftypes.v1.ApprovalStrategy
 */
export enum ApprovalStrategy {
  /**
   * @generated from enum value: APPROVAL_STRATEGY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 全員承認: all designated approvers must approve.
   *
   * @generated from enum value: APPROVAL_STRATEGY_ALL = 1;
   */
  ALL = 1,

  /**
   * 誰か1人: any single designated approver suffices.
   *
   * @generated from enum value: APPROVAL_STRATEGY_ANY = 2;
   */
  ANY = 2,
}

/**
 * Describes the enum bfftypes.v1.ApprovalStrategy.
 */
export const ApprovalStrategySchema: GenEnum<ApprovalStrategy> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_approval_flow_type, 1);

/**
 * PlanningSection identifies the operational planning horizon.
 *
 * Wire values mirror backend types.v1.PlanningSection.
 *
 * @generated from enum bfftypes.v1.PlanningSection
 */
export enum PlanningSection {
  /**
   * @generated from enum value: PLANNING_SECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 当日
   *
   * @generated from enum value: PLANNING_SECTION_TODAY = 1;
   */
  TODAY = 1,

  /**
   * 翌日
   *
   * @generated from enum value: PLANNING_SECTION_TOMORROW = 2;
   */
  TOMORROW = 2,

  /**
   * 翌々日
   *
   * @generated from enum value: PLANNING_SECTION_DAY_AFTER_TOMORROW = 3;
   */
  DAY_AFTER_TOMORROW = 3,

  /**
   * 週間
   *
   * @generated from enum value: PLANNING_SECTION_WEEKLY = 4;
   */
  WEEKLY = 4,

  /**
   * 月間
   *
   * @generated from enum value: PLANNING_SECTION_MONTHLY = 5;
   */
  MONTHLY = 5,

  /**
   * 年間
   *
   * @generated from enum value: PLANNING_SECTION_ANNUAL = 6;
   */
  ANNUAL = 6,
}

/**
 * Describes the enum bfftypes.v1.PlanningSection.
 */
export const PlanningSectionSchema: GenEnum<PlanningSection> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_approval_flow_type, 2);

/**
 * SwitchReason identifies why an approval mode was automatically switched.
 *
 * Wire values mirror backend types.v1.SwitchReason.
 *
 * @generated from enum bfftypes.v1.SwitchReason
 */
export enum SwitchReason {
  /**
   * @generated from enum value: SWITCH_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 乖離: plan variance exceeded the threshold.
   *
   * @generated from enum value: SWITCH_REASON_VARIANCE = 1;
   */
  VARIANCE = 1,

  /**
   * 締切: the deadline passed without approval.
   *
   * @generated from enum value: SWITCH_REASON_DEADLINE = 2;
   */
  DEADLINE = 2,

  /**
   * 設定変更: a manual configuration change.
   *
   * @generated from enum value: SWITCH_REASON_MANUAL = 3;
   */
  MANUAL = 3,
}

/**
 * Describes the enum bfftypes.v1.SwitchReason.
 */
export const SwitchReasonSchema: GenEnum<SwitchReason> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_approval_flow_type, 3);

/**
 * ApprovalMode represents how an approval flow operates for a given cell.
 * Intentionally named without a "Bidding" prefix because the concept is
 * cross-domain (not limited to bidding). BiddingApprovalMode in
 * bffuser.v1 remains as-is for backward compatibility.
 *
 * Wire values mirror backend internalapi.v1.ApprovalMode.
 *
 * @generated from enum bfftypes.v1.ApprovalMode
 */
export enum ApprovalMode {
  /**
   * @generated from enum value: APPROVAL_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 承認: 承認者の承認後に操作可能。
   *
   * @generated from enum value: APPROVAL_MODE_APPROVAL = 1;
   */
  APPROVAL = 1,

  /**
   * 自動: 承認ステップなしで自動処理。
   *
   * @generated from enum value: APPROVAL_MODE_AUTO = 2;
   */
  AUTO = 2,

  /**
   * 承認なし: 承認プロセスは無いが担当者が手動で完了操作。
   *
   * @generated from enum value: APPROVAL_MODE_NO_APPROVAL = 3;
   */
  NO_APPROVAL = 3,
}

/**
 * Describes the enum bfftypes.v1.ApprovalMode.
 */
export const ApprovalModeSchema: GenEnum<ApprovalMode> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_approval_flow_type, 4);

/**
 * WorkflowSchedule mirrors backend internalapi.v1.WorkflowSchedule.
 *
 * @generated from enum bfftypes.v1.WorkflowSchedule
 */
export enum WorkflowSchedule {
  /**
   * @generated from enum value: WORKFLOW_SCHEDULE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_SCHEDULE_REGULAR = 1;
   */
  REGULAR = 1,

  /**
   * @generated from enum value: WORKFLOW_SCHEDULE_CHANGE = 2;
   */
  CHANGE = 2,
}

/**
 * Describes the enum bfftypes.v1.WorkflowSchedule.
 */
export const WorkflowScheduleSchema: GenEnum<WorkflowSchedule> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_approval_flow_type, 5);

